module.exports = __webpack_public_path__ + "img/mobile/BetBar-freespins/fs-spins-bg@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar-freespins/fs-spins-bg@1x.png
// module id = 181
// module chunks = 0